import { PLATFORM } from 'aurelia-framework';

export const tabRoutes = [
  {
    route: [''],
    name: 'tab-navision',
    moduleId: PLATFORM.moduleName('./waste-tab-navision'),
    tabindex: 0,
    entityShortName: 'waste-tab-navision',
  },
  {
    route: ['/delta'],
    name: 'tab-delta',
    moduleId: PLATFORM.moduleName('./waste-tab-delta'),
    tabindex: 1,
    entityShortName: 'waste-tab-delta',
  },
  {
    route: ['/xledger'],
    name: 'tab-xledger',
    moduleId: PLATFORM.moduleName('./waste-tab-xledger'),
    tabindex: 2,
    entityShortName: 'waste-tab-xledger',
  },
  {
    route: ['/bcvoninrefa'],
    name: 'tab-bcvoninrefa',
    moduleId: PLATFORM.moduleName('./waste-tab-bcvoninrefa'),
    tabindex: 3,
    entityShortName: 'waste-tab-bcvoninrefa',
  },
  {
    route: ['/bcfaroeislands'],
    name: 'tab-bcfaroeislands',
    moduleId: PLATFORM.moduleName('./waste-tab-bcfaroeislands'),
    tabindex: 4,
    entityShortName: 'waste-tab-bcfaroeislands',
  },
];
